import $ from 'jquery';
import { Accordion as FoundationAccordion }  from 'foundation-sites/js/foundation.accordion';

/**
 * 
 * Accordion element related functions
 * 
 */

const Accordion = (() => {

    const EL_SELECTOR = ".accordion";
    const EXPAND_SELECTOR = ".link--expand";
    const COLLAPSE_SELECTOR = ".link--collapse";

    const initialize = () => {

        const $accordionElements = $(EL_SELECTOR);

        if ($accordionElements.length) {
            
            // check for hash in url
            $accordionElements.each((idx, el) => {
                const $el = $(el);
                /* const accordion = new Foundation.Accordion($el); */

                // get control buttons and bind event handler
                $(EXPAND_SELECTOR, $el).on('click', (e) => {
                    e.preventDefault;
                    $el.foundation('down', $($el.find('.accordion-content')));
                })
                $(COLLAPSE_SELECTOR, $el).on('click', (e) => {
                    e.preventDefault;
                    $el.foundation('up', $($el.find('.accordion-content')));
                })
                
            })
        }
    }

    return {
        init: initialize
    }

})($);

export default Accordion;